import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimuladorLiquidoPrevidenciaComponent } from 'src/app/shared/pdf/simulador-liquido-previdencia/simulador-liquido-previdencia.component';
import { SimuladorLiquidoService } from '../../../services/previdencia/simulador-liquido.service';
@Component({
  selector: 'app-simulacao-previdencia',
  templateUrl: './simulacao-previdencia.component.html',
  styleUrls: ['./simulacao-previdencia.component.css']
})
export class SimulacaoPrevidenciaComponent {
  faPdf = faFilePdf;
  @Input() valor: any = null;
  @Output() errorToEmit = new EventEmitter<any>();
  //Variaveis personalizacao simulacao
  valorMinimoIdade: number = 45;
  valorMaximoIdade: number = 110;
  //Listas
  meses: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
  taxa: string[] = ['4', '5', '6'];
  //variaveis no sistema
  dataAtual: string = new Date().toLocaleDateString("pt-BR");
  loading: boolean = false;
  loadingPrint: boolean = false;
  loadingCosts: boolean = false;
  simulation: any = null;
  ResgateParcial: any = null;
  formGroup: FormGroup = new FormGroup({
    anoAposentar: new FormControl(null, [Validators.required]),
    mesAposentar: new FormControl(null, [Validators.required]),
    aporte: new FormControl(null, [Validators.required]),
    contribuicaoFacultativa: new FormControl(null, [Validators.required]),
    contribuicaoParticipante: new FormControl(null, [Validators.required]),
    contribuicaoPatrocinadora: new FormControl(null, [Validators.required]),
    taxaJuros: new FormControl(null),
    ValorExpectativa: new FormControl(null)
  });
  constructor(private simuladorLiquidoService: SimuladorLiquidoService, private modalService: NgbModal) {
    this.consultar();
  }
  consultar() {
    this.loading = true;
    this.loadingCosts = !this.loadingCosts;
    this.simuladorLiquidoService.getSimuladorLiquido(this.formGroup.value).subscribe(
      {
        next: (res: any) => {
          this.simulation = res;
          this.ResgateParcial = res.resgate[1];
          this.loadingCosts = !this.loadingCosts;
          this.formGroup.patchValue(res.filtro);
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      }
    );
  }
  printPdf() {
    const modalRef = this.modalService.open(SimuladorLiquidoPrevidenciaComponent, { windowClass: 'custom-modal-size-imprimir', size: 'lg', centered: true });
    modalRef.componentInstance.simulacao = this.simulation;
  }
}
